@if (unlicensed()) {
  <!--
    No cancel here; the vault-row menu and the My requests tab still withdraw a request, and
    neither is licensing-gated.
  -->
  <bit-card class="tw-mb-5 bit-compact:tw-mb-4" data-testid="cipher-view-banner-unlicensed">
    <div class="tw-flex tw-items-start tw-gap-4">
      <bit-icon-tile icon="bwi-info-circle" variant="primary" size="sm" />
      <div class="tw-flex tw-min-w-0 tw-grow tw-flex-col tw-gap-2 tw-text-fg-body">
        <div class="tw-flex tw-flex-col">
          <h3 bitTypography="h5" noMargin>{{ "pamUnlicensedBannerHeading" | i18n }}</h3>

          <p bitTypography="helper" class="tw-m-0 tw-text-fg-body-subtle">
            {{ "pamUnlicensedBannerBody" | i18n }}
          </p>
        </div>

        <p bitTypography="helper" class="tw-m-0 tw-text-fg-body-subtle">
          {{ "pamUnlicensedBannerRequestUnavailable" | i18n }}
        </p>
      </div>
    </div>
  </bit-card>
} @else if (activeLease(); as lease) {
  <bit-card class="tw-mb-5 bit-compact:tw-mb-4" data-testid="cipher-view-banner-active">
    <div class="tw-flex tw-items-start tw-gap-4">
      <bit-icon-tile
        [icon]="leaseEndingSoon() ? 'bwi-exclamation-triangle' : 'bwi-clock'"
        [variant]="leaseEndingSoon() ? 'danger' : 'teal'"
        size="sm"
      />
      <div class="tw-flex tw-min-w-0 tw-grow tw-flex-col tw-gap-2 tw-text-fg-body">
        <div class="tw-flex tw-flex-col">
          @if (leaseEndingSoon()) {
            <h3 bitTypography="h5" noMargin data-testid="active-lease-ending-soon">
              {{ "pamActiveLeaseBannerEndingSoonTitle" | i18n: leaseRemainingLabel() }}
            </h3>
          } @else {
            <h3 bitTypography="h5" noMargin data-testid="active-lease-countdown">
              {{ "pamActiveLeaseBannerTitle" | i18n: leaseRemainingLabel() }}
            </h3>
          }
          <span
            bitTypography="helper"
            class="tw-text-fg-body-subtle"
            data-testid="active-lease-ends-at"
          >
            {{ "pamWindowUntil" | i18n: (lease.notAfter | date: "short") }}
          </span>
        </div>

        <span class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
          @if (canExtendLease()) {
            <button
              type="button"
              bitButton
              buttonType="secondary"
              size="small"
              [bitAction]="extendLease"
              id="pam-cipher-view-banner_button_extend"
            >
              {{ "pamExtendLeaseButton" | i18n }}
            </button>
          }
          <button
            type="button"
            bitButton
            buttonType="danger"
            size="small"
            [bitAction]="endLease"
            id="pam-cipher-view-banner_button_end"
          >
            {{ "pamEndLeaseButton" | i18n }}
          </button>
        </span>
      </div>
    </div>
  </bit-card>
} @else if (approvedRequest(); as request) {
  <bit-card class="tw-mb-5 bit-compact:tw-mb-4" data-testid="cipher-view-banner-approved">
    <div class="tw-flex tw-items-start tw-gap-4">
      <bit-icon-tile icon="bwi-check-circle" variant="success" size="sm" />
      <div class="tw-flex tw-min-w-0 tw-grow tw-flex-col tw-gap-2 tw-text-fg-body">
        <div class="tw-flex tw-flex-col">
          <h3 bitTypography="h5" noMargin>{{ "pamApprovedRequestBannerHeading" | i18n }}</h3>

          @if (approvedDurationSeconds(); as grantedSeconds) {
            <p
              bitTypography="helper"
              class="tw-m-0 tw-flex tw-items-center tw-gap-2 tw-text-fg-body-subtle"
              data-testid="cipher-view-banner-approved-duration"
            >
              <bit-icon name="bwi-clock" />
              {{ "pamApprovedRequestBannerDuration" | i18n: (grantedSeconds | durationLong) }}
            </p>
          }
        </div>

        <div class="tw-flex tw-flex-col tw-items-start tw-gap-2">
          <span bitTypography="body2" data-testid="approved-access-window">
            @if (approvedRequestStartsNow()) {
              {{ "pamWindowUntil" | i18n: (request.leaseNotAfter | date: "short") }}
            } @else {
              {{ request.leaseNotBefore | date: "short" }} &ndash;
              {{ request.leaseNotAfter | date: "short" }}
            }
          </span>
          <span class="tw-flex tw-items-center tw-gap-2">
            <button
              type="button"
              bitButton
              buttonType="primary"
              size="small"
              [bitAction]="activateRequest"
              id="pam-cipher-view-banner_button_start"
            >
              {{ "pamStartLeaseButton" | i18n }}
            </button>
            <button
              type="button"
              bitButton
              buttonType="secondary"
              size="small"
              [bitAction]="cancelRequest"
              id="pam-cipher-view-banner_button_cancel-approved"
            >
              {{ "pendingStateCancelRequest" | i18n }}
            </button>
          </span>
        </div>
      </div>
    </div>
  </bit-card>
} @else if (pendingRequest()) {
  <bit-card class="tw-mb-5 bit-compact:tw-mb-4" data-testid="cipher-view-banner-pending">
    <div class="tw-flex tw-items-start tw-gap-4">
      <bit-icon-tile icon="bwi-clock" variant="warning" size="sm" />
      <div class="tw-flex tw-min-w-0 tw-grow tw-flex-col tw-gap-2 tw-text-fg-body">
        <h3 bitTypography="h5" noMargin>{{ "pamPendingRequestBannerHeading" | i18n }}</h3>

        <div class="tw-flex tw-flex-col tw-items-start tw-gap-2">
          <button
            type="button"
            bitButton
            buttonType="secondary"
            size="small"
            [bitAction]="cancelRequest"
            id="pam-cipher-view-banner_button_cancel"
          >
            {{ "pendingStateCancelRequest" | i18n }}
          </button>
        </div>
      </div>
    </div>
  </bit-card>
} @else if (canRequestAccess()) {
  <bit-card class="tw-mb-5 bit-compact:tw-mb-4" data-testid="cipher-view-banner-request">
    <div class="tw-flex tw-items-start tw-gap-4">
      <bit-icon-tile icon="bwi-key" variant="primary" size="sm" />
      <div class="tw-flex tw-min-w-0 tw-grow tw-flex-col tw-gap-2 tw-text-fg-body">
        <div class="tw-flex tw-flex-col">
          <h3 bitTypography="h5" noMargin>{{ "pamRequestAccessBannerHeading" | i18n }}</h3>

          <p bitTypography="helper" class="tw-m-0 tw-text-fg-body-subtle">
            {{ "pamRequestAccessBannerBody" | i18n }}
          </p>
        </div>

        @if (restingRequestTerms(); as terms) {
          <p
            bitTypography="body2"
            class="tw-m-0 tw-flex tw-items-center tw-gap-2"
            data-testid="cipher-view-banner-max-duration"
          >
            <bit-icon name="bwi-clock" />
            {{ terms.messageKey | i18n: (terms.maxSeconds | durationLong) }}
          </p>
        }

        @if (!requestFormExpanded()) {
          <div class="tw-flex tw-flex-col tw-items-start tw-gap-2">
            <button
              #requestToggleButton
              type="button"
              bitButton
              buttonType="primary"
              size="small"
              (click)="toggleRequestForm()"
              id="pam-cipher-view-banner_button_request-toggle"
            >
              {{ "pamRequestAccessButton" | i18n }}
            </button>
          </div>
        }
      </div>
    </div>

    @if (requestFormExpanded()) {
      <div
        class="tw-text-fg-body"
        #requestFoldOut
        tabindex="-1"
        role="group"
        [attr.aria-label]="'pamRequestAccessButton' | i18n"
      >
        <hr class="tw-my-4 tw-border-t tw-border-border-base" />

        @if (loadingRequestForm()) {
          <p bitTypography="body2" class="tw-m-0">{{ "loading" | i18n }}</p>
        } @else if (requestMode() !== null) {
          @if (slotContention(); as contention) {
            <!--
              Replaces the description, whose immediate-access copy is false while the slot is
              taken. The form stays enabled, since the request is still worth making.
            -->
            <p bitTypography="body2" class="tw-mb-4 tw-mt-0 tw-flex tw-items-start tw-gap-2">
              <bit-icon name="bwi-exclamation-triangle" class="tw-mt-0.5 tw-text-warning" />
              <span>
                @if (contention.freesAt) {
                  {{ "pamRequestSlotTakenUntil" | i18n: (contention.freesAt | date: "short") }}
                } @else {
                  {{ "pamRequestSlotTaken" | i18n }}
                }
              </span>
            </p>
          } @else {
            <p bitTypography="body2" class="tw-mb-4 tw-mt-0">
              @if (requestMode() === "automatic") {
                {{ "requestAccessModalAutomaticDescription" | i18n }}
              } @else {
                {{ "requestAccessModalHumanDescription" | i18n }}
              }
            </p>
          }

          @if (requestMode() === "automatic") {
            <form [formGroup]="automaticForm" class="tw-flex tw-flex-col tw-gap-4">
              <bit-form-field>
                <bit-label>{{ "requestAccessModalDuration" | i18n }}</bit-label>
                <select
                  bitInput
                  formControlName="durationSeconds"
                  id="pam-cipher-view-banner_select_duration"
                >
                  @for (option of durationOptions(); track option.seconds) {
                    <option [value]="option.seconds">
                      {{
                        option.labelKey
                          ? (option.labelKey | i18n)
                          : (option.seconds | durationShort)
                      }}
                    </option>
                  }
                </select>
              </bit-form-field>

              <bit-form-field>
                <bit-label>{{ "requestAccessModalReasonOptional" | i18n }}</bit-label>
                <textarea
                  bitInput
                  rows="3"
                  formControlName="reason"
                  [placeholder]="'requestAccessModalReasonPlaceholder' | i18n"
                  id="pam-cipher-view-banner_textarea_automatic-reason"
                ></textarea>
                <bit-hint>{{ "requestAccessModalAutomaticReasonHint" | i18n }}</bit-hint>
              </bit-form-field>
            </form>
          } @else {
            <form [formGroup]="humanForm" class="tw-flex tw-flex-col tw-gap-4">
              <div class="tw-grid tw-grid-cols-2 tw-gap-3">
                <bit-form-field>
                  <bit-label>{{ "requestAccessModalStartDate" | i18n }}</bit-label>
                  <input
                    bitInput
                    type="date"
                    formControlName="startDate"
                    [min]="minRequestDate()"
                    id="pam-cipher-view-banner_input_start-date"
                  />
                </bit-form-field>
                <bit-form-field>
                  <bit-label>{{ "requestAccessModalStart" | i18n }}</bit-label>
                  @if (customStart()) {
                    <input
                      bitInput
                      type="time"
                      formControlName="startTime"
                      id="pam-cipher-view-banner_input_start"
                    />
                  } @else {
                    <select
                      bitInput
                      [formControl]="startSlot"
                      id="pam-cipher-view-banner_select_start"
                    >
                      @for (slot of startSlots(); track slot.value) {
                        <option [value]="slot.value">{{ slot.label }}</option>
                      }
                      <option [value]="CUSTOM_OPTION">
                        {{ "requestAccessModalCustomOption" | i18n }}
                      </option>
                    </select>
                  }
                  @if (customStart()) {
                    <button
                      type="button"
                      bitSuffix
                      bitIconButton="bwi-list"
                      [label]="'requestAccessModalShowStartPresets' | i18n"
                      (click)="showStartPresets()"
                      id="pam-cipher-view-banner_button_start-presets"
                    ></button>
                  }
                </bit-form-field>
              </div>

              @if (customEnd()) {
                <div class="tw-grid tw-grid-cols-2 tw-gap-3">
                  <bit-form-field>
                    <bit-label>{{ "requestAccessModalEndDate" | i18n }}</bit-label>
                    <input
                      bitInput
                      type="date"
                      formControlName="endDate"
                      [min]="minEndDate()"
                      id="pam-cipher-view-banner_input_end-date"
                    />
                  </bit-form-field>
                  <bit-form-field>
                    <bit-label>{{ "requestAccessModalEnd" | i18n }}</bit-label>
                    <input
                      bitInput
                      type="time"
                      formControlName="endTime"
                      id="pam-cipher-view-banner_input_end"
                    />
                    <button
                      type="button"
                      bitSuffix
                      bitIconButton="bwi-undo"
                      [label]="'requestAccessModalShowEndPresets' | i18n"
                      (click)="showEndPresets()"
                      id="pam-cipher-view-banner_button_end-presets"
                    ></button>
                  </bit-form-field>
                </div>
              } @else {
                <bit-form-field>
                  <bit-label>{{ "requestAccessModalDuration" | i18n }}</bit-label>
                  <select
                    bitInput
                    [formControl]="endDuration"
                    id="pam-cipher-view-banner_select_end"
                  >
                    @for (option of endOptions(); track option.seconds) {
                      <option [value]="option.seconds">{{ option.label }}</option>
                    }
                    <option [value]="CUSTOM_OPTION">
                      {{ "requestAccessModalCustomEndOption" | i18n }}
                    </option>
                  </select>
                </bit-form-field>
              }

              @if (durationWindowError(); as error) {
                <p
                  bitTypography="helper"
                  class="-tw-mt-2 tw-mb-0 tw-text-danger"
                  data-testid="request-window-error"
                >
                  {{ error }}
                </p>
              } @else if (windowSummary(); as summary) {
                <p
                  bitTypography="helper"
                  class="-tw-mt-2 tw-mb-0 tw-text-muted"
                  data-testid="request-window-summary"
                >
                  {{ summary }}
                </p>
              }

              <bit-form-field>
                <bit-label>{{ "requestAccessModalReasonRequired" | i18n }}</bit-label>
                <textarea
                  bitInput
                  rows="3"
                  formControlName="reason"
                  [placeholder]="'requestAccessModalReasonPlaceholder' | i18n"
                  id="pam-cipher-view-banner_textarea_human-reason"
                ></textarea>
                <bit-hint>{{ "requestAccessModalHumanReasonHint" | i18n }}</bit-hint>
              </bit-form-field>
            </form>
          }
        }

        @if (requestError(); as error) {
          <p
            bitTypography="helper"
            role="alert"
            class="tw-mb-0 tw-mt-3 tw-flex tw-items-start tw-gap-2 tw-text-danger"
            data-testid="request-error"
          >
            <bit-icon name="bwi-error" class="tw-mt-0.5" />
            <span>{{ error }}</span>
          </p>
        }

        <div class="tw-mt-4 tw-flex tw-items-center tw-justify-end tw-gap-2">
          @if (requestMode() !== null) {
            <button
              type="button"
              bitButton
              buttonType="primary"
              size="small"
              [bitAction]="submitRequest"
              id="pam-cipher-view-banner_button_request-submit"
            >
              {{ "requestAccessModalSubmit" | i18n }}
            </button>
          }
          <button
            type="button"
            bitButton
            buttonType="secondary"
            size="small"
            (click)="toggleRequestForm()"
            id="pam-cipher-view-banner_button_request-cancel"
          >
            {{ "cancel" | i18n }}
          </button>
        </div>
      </div>
    }
  </bit-card>
}
